export const gamerule = {
    points_for_normal_riddle: 60,
    points_for_bonus_riddle: 100,
}